module.exports = __webpack_public_path__ + "static/media/twitter.d673875a.svg";